import { CheckCircle, Pencil, Trash2, XCircle } from "lucide-react";

export const getVaccinesRowActions = ({ onToggle, onEdit, onDelete }) => [
  {
    label: "Enable",
    icon: CheckCircle,
    primary: true,
    visibleWhen: (row) => row.disabled === true,
    onClick: onToggle,
  },
  {
    label: "Disable",
    icon: XCircle,
    primary: true,
    visibleWhen: (row) => row.disabled !== true,
    onClick: onToggle,
  },
  {
    label: "Edit",
    icon: Pencil,
    primary: true,
    onClick: onEdit,
  },
  {
    label: "Delete",
    icon: Trash2,
    primary: true,
    onClick: onDelete,
  },
];
